import script from "./mapConfig2.vue?vue&type=script&setup=true&lang=js"
export * from "./mapConfig2.vue?vue&type=script&setup=true&lang=js"

import "./mapConfig2.vue?vue&type=style&index=0&id=daccbeb8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-daccbeb8"]])

export default __exports__